import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import '../App.css';

export default function LoginPage() {
  const location = useLocation();
  const { loginWithSso, isAuthenticated, shouldBypassAuth } = useAuth();

  // If already authenticated, redirect to intended destination or home.
  if (isAuthenticated || shouldBypassAuth) {
    const fromPath = location.state?.from?.pathname || '/';
    return <Navigate to={fromPath} replace />;
  }

  const handleLogin = () => {
    loginWithSso();
  };

  return (
    <div className="LoginPage">
      <div className="LoginPage__overlay" />
      <div className="LoginPage__content">
        <div className="LoginPage__card">
          <div className="LoginPage__branding">
            <h3 className="LoginPage__eyebrow">PRESIDIO</h3>
            <h1 className="LoginPage__title">DIGITAL</h1>
          </div>

          <button type="button" className="LoginPage__ssoButton" onClick={handleLogin}>
            <span className="LoginPage__ssoIcon" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </span>
            <span className="LoginPage__ssoLabel">Login with Presidio SSO</span>
          </button>
        </div>
      </div>
    </div>
  );
}

